import React from 'react';
import { Hidden, Grid, useTheme, useMediaQuery } from '@material-ui/core';
import { Container, Image } from 'components';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { Link } from 'react-router-dom';

import './styles.sass';

function ShopOurDevices(): React.ReactElement {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'));

  return (
    <div className="home-section-phone">
      <Container disableGutters={isTablet}>
        <div className="home-section-phone-content">
          <Grid container justify="space-between" className={'home-section-phone-wrapper'}>
            <Grid item xs={12} sm={5} container justify="center" direction="column">
              <p className="home-section-phone-text-1">You can even get 0% financing on a new phone if you’re looking to upgrade.</p>
              <p className="home-section-phone-text-2">Take up to two years to pay and we&#x27;ll cover the interest on your behalf — even if you decide to switch to another carrier.</p>
              <Link to="shop"><p className="home-section-phone-go-to-devices flex-row">Shop our devices <ArrowRightAltIcon /></p></Link>
            </Grid>
            <Hidden only="xs">
              <Grid item xs={12} sm={6} className="home-section-phone-flex">
                <Image
                  src="/images/img-apple.jpg"
                  wrapperClassName="home-section-phone-img-wrapper"
                  className="home-section-phone-img"
                />
              </Grid>
            </Hidden>
          </Grid>
        </div>
      </Container>
      <Hidden smUp>
        <Image
          src="/images/img-apple.jpg"
          wrapperClassName="home-section-phone-img-wrapper"
          className="home-section-phone-img"
        />
      </Hidden>
    </div>
  )
}

export default ShopOurDevices;
